module.exports = __webpack_public_path__ + "static/shopify-54212587f03312522c4471668dddc6bb.svg";